<template>
  <div class="process-node-main-box">
    <ul class="process-node-item-box">
      <li v-for="(item, index) in nodeArr" :key="index">
        <i></i>
        <span :style="index === 0 ? 'color: #0d4b87' : ''">{{
          item.nodeWay
        }}</span>
        <span
          >【{{
            item.type
              ? item.type == "1"
                ? "司机"
                : item.type == "2"
                ? "客服"
                : item.type == "3"
                ? "调度"
                : item.type == "4"
                ? "库管"
                : item.type == "5"
                ? "门卫"
                : ""
              : "暂无"
          }}】&nbsp;{{ item.nodeName }}</span
        >
        <span>{{ item.nodeDate }}</span>
        <!-- 'el-icon-check', -->
        <span
          :class="[
            item.status == '2' ||
            item.status == '4' ||
            item.status == '9' ||
            item.status == '12' ||
            item.status == '14'
              ? 'isShowBtn'
              : 'isHiddenBtn',
          ]"
          @click="handleBack(item)"
          v-if="isBack"
          >回退</span
        >
        <span v-else></span>

        <span
          v-if="item.remark"
          :class="[item.remark ? 'isShowBtn' : 'isHiddenBtn']"
          >{{ item.remark }}</span
        >
        <span v-else></span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    nodeArr: {
      type: Array,
      default: () => {
        return [];
      },
    },
    isBack: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    handleBack(pItem) {
      console.log("处理回退");
      this.$emit("processRollback", pItem);
    },
  },
};
</script>

<style lang="scss" scoped>
.process-node-main-box {
  width: 100%;
  height: 100%;
  .process-node-item-box {
    margin-left: 56px;
    height: 100%;
    display: flex;
    flex-direction: column;
    // justify-content: space-around;
    li {
      width: 100%;
      height: 50px;
      min-height: 50px;
      display: flex;
      flex-direction: row;

      :nth-child(1) {
        display: inline-block;
        width: 20px;
        height: 20px;
        background-color: #0d4b87;
        border-radius: 50%;
        margin: 0 30px 0 0;
        &:after {
          content: "";
          display: block;
          clear: both;
          width: 1px;
          height: 50px;
          background-color: #0d4b87;
          margin: 8px auto;
        }
      }
      :nth-child(2) {
        width: 120px;
        height: 16px;
        font-size: 13px;
        color: black;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      :nth-child(2):hover {
        overflow: visible;
        white-space: normal;
      }
      :nth-child(3) {
        width: 150px;
        height: 16px;
        font-size: 13px;
        color: black;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      :nth-child(3):hover {
        overflow: visible;
        white-space: normal;
      }
      :nth-child(4) {
        width: 180px;
        height: 16px;
        font-size: 13px;
        color: black;
      }
      :nth-child(5) {
        font-size: 13px;
        color: #0d4b87;
        display: inline-block;
        width: 80px;
        height: 26px;
        cursor: pointer;
      }
      :nth-child(6) {
        font-size: 13px;
        color: black;
        display: inline-block;
        width: 80px;
        height: 26px;
        white-space: nowrap; /* 确保文本在一行内显示 */
        overflow: hidden; /* 隐藏溢出的内容 */
        text-overflow: ellipsis; /* 使用省略号表示溢出的文本 */
      }
      :nth-child(6):hover {
        overflow: visible; /* 鼠标悬停时显示全文 */
        white-space: normal; /* 允许换行 */
      }

      .isHiddenBtn {
        visibility: hidden;
      }
      .isShowBtn {
        visibility: visible;
      }
    }
    li:first-child {
      :nth-child(5) {
        visibility: hidden;
      }
    }
    li:last-child {
      :nth-child(1) {
        display: inline-block;
        width: 20px;
        height: 20px;
        background-color: #0d4b87;
        border-radius: 50%;
        margin: 0 30px 0 0;
        &:after {
          display: none;
        }
      }
      :nth-child(5) {
        visibility: hidden;
      }
    }
  }
}
</style>
